import React from 'react';
import {
    SelectedFilters,
} from '@appbaseio/reactivesearch';
import {selectedFiltersContainer} from "../styles/Container";

const SelectedFilterArea = ({ visible }) => (
    <SelectedFilters
        className={selectedFiltersContainer}
    />
);


export default SelectedFilterArea;


// WEBPACK FOOTER //
// ./src/components/SelectedFilters.js